"use client";

import { useEffect } from "react";

export function GetAcquisitionMarker() {
  useEffect(() => {
    document.cookie = "acq_bucket=self_serve_get; Max-Age=2592000; Path=/; SameSite=Lax";
  }, []);

  return null;
}
